import { lazy } from 'react';
import { Routes } from '../../utils/constants';

const LoginPage = lazy(() => import('../../pages/login'));
const SampleContentPage = lazy(() => import('../../pages/sample/content'));
const SampleFacultiesPage = lazy(() => import('../../pages/sample/faculties'));
const SampleWatchPage = lazy(() => import('../../pages/sample/watch'));
const SampleStoryStopPage = lazy(() => import('../../pages/sample/story-stop'));
const SampleNewHqPage = lazy(() => import('../../pages/sample/new-hq'));

const SampleStoryStopContentPage = lazy(
  () => import('../../pages/sample/story-stop/story-stop-content'),
);

const SampleProgrammesPage = lazy(
  () => import('../../pages/sample/programmes'),
);

const SampleCriticalThinkingPage = lazy(
  () => import('../../pages/sample/critical-thinking'),
);

const SamplePledgePage = lazy(() => import('../../pages/sample/pledge'));
const SampleGameStopPage = lazy(() => import('../../pages/sample/game-stop'));

export const publicRoutes = [
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
  },
  {
    name: 'Free New HQ Page',
    path: Routes.sampleNewHq,
    component: SampleNewHqPage,
  },
  {
    name: 'Free Faculties Page',
    path: Routes.sampleFaculties,
    component: SampleFacultiesPage,
  },
  {
    name: 'Free Programmes Page',
    path: Routes.sampleProgrammes(),
    component: SampleProgrammesPage,
  },
  {
    name: 'Free Content Page',
    path: Routes.sampleContent(),
    component: SampleContentPage,
  },
  {
    name: 'Free Watch Page',
    path: Routes.sampleWatch(),
    component: SampleWatchPage,
  },
  {
    name: 'Sample Critical Thinking Page',
    path: Routes.sampleCriticalThinking,
    component: SampleCriticalThinkingPage,
  },
  {
    name: 'Sample Story Stop Page',
    path: Routes.sampleStoryStop(),
    component: SampleStoryStopPage,
  },
  {
    name: 'Sample Story Stop Content Page',
    path: Routes.sampleStoryStopContent(),
    component: SampleStoryStopContentPage,
  },
  {
    name: 'Sample Pledge Page',
    path: Routes.samplePledge(),
    component: SamplePledgePage,
  },
  {
    name: 'Sample Game Stop Page',
    path: Routes.sampleGameStop,
    component: SampleGameStopPage,
  },
];
